export default __webpack_public_path__ + "static/media/cp_geo_fk.55f09b0a.svg";